(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-on-lagos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var FULL_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var COLS = ['id','event_name','category','date','end_date','time','venue_name','area','price_from','ticket_url','map_url','ezomi_pick','status','source','notes'];
  var STORE_KEY = 'ezomi-detty-filters-v1';

  var TAGS = {
    festival: { bg: 'color-mix(in oklch, var(--rose-500) 24%, var(--cream-50))', fg: 'var(--wine-800)' },
    concert: { bg: 'color-mix(in oklch, var(--wine-800) 12%, var(--cream-50))', fg: 'var(--wine-800)' },
    'nightlife-lounge': { bg: 'color-mix(in oklch, var(--wine-900) 16%, var(--cream-50))', fg: 'var(--wine-900)' },
    'play-theatre': { bg: 'color-mix(in oklch, var(--sand-300) 48%, var(--cream-50))', fg: 'var(--wine-800)' },
    fashion: { bg: 'color-mix(in oklch, var(--rose-300) 45%, var(--cream-50))', fg: 'var(--wine-700)' },
    'brunch-day-party': { bg: 'var(--sand-100)', fg: 'var(--wine-700)' },
    'art-culture': { bg: 'color-mix(in oklch, var(--taupe-600) 18%, var(--cream-50))', fg: 'var(--ink)' },
    comedy: { bg: 'color-mix(in oklch, var(--sand-300) 28%, var(--cream-50))', fg: 'var(--wine-900)' }
  };
  var LABELS = {
    festival: 'Festivals', concert: 'Concerts', 'nightlife-lounge': 'Nightlife & Lounges',
    'play-theatre': 'Plays & Theatre', fashion: 'Fashion', 'brunch-day-party': 'Brunch & Day Parties',
    'art-culture': 'Art & Culture', comedy: 'Comedy'
  };
  var FALLBACK_TAG = { bg: 'var(--surface-sunken)', fg: 'var(--wine-800)' };

  // Fallback sample data — renders instantly while the sheet fetch resolves,
  // and keeps the page from ever being empty if the sheet is unreachable.
  var SEED = [
    '1|Flytime Fest|festival|2026-12-22|2026-12-25|7:00 PM|Eko Convention Centre|Victoria Island|NGN 40000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Eko+Convention+Centre+Victoria+Island+Lagos|TRUE|upcoming|@flytimehq|Multi-day; the season anchor. Sells out — book early.',
    '2|Rhythm Unplugged|concert|2026-12-21||6:00 PM|Eko Energy City|Victoria Island|NGN 25000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Eko+Energy+City+Victoria+Island+Lagos|TRUE|upcoming|@rhythmunpluggedhq|Big cross-over line-up.',
    '3|Palmwine Music Festival|festival|2026-12-21||4:00 PM|The Fidelity Ground|Oniru|NGN 20000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=The+Fidelity+Ground+Oniru+Lagos|TRUE|upcoming|@palmwinemusicfest|Culture-forward crowd; come for the crate-diggers.',
    '4|Detty December Fest|festival|2026-12-06|2026-12-31|Varies|Ilubirin|Ikoyi|Free-paid|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Ilubirin+Ikoyi+Lagos|FALSE|upcoming|@dettydecfest|Month-long; Livespot360. Programme varies by day.',
    '5|Fashion Souk|fashion|2026-12-06|2026-12-07|11:00 AM|Harbour Point|Victoria Island|NGN 10000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Harbour+Point+Victoria+Island+Lagos|TRUE|upcoming|@fashionsouk|Shopping + gifting; the best daytime option of the weekend.',
    '6|SundaySocials — The Brunch Experience|brunch-day-party|2026-12-14||1:00 PM|Clubhouse Lagos (Landmark Towers)|Victoria Island|NGN 15000|DM to book|https://www.google.com/maps/search/?api=1&query=Landmark+Towers+Victoria+Island+Lagos|TRUE|upcoming|@sundaysocials|Afrohouse and amapiano brunch; recurring Sundays.',
    '7|El Padrino Pool Club|brunch-day-party|2026-12-20||2:00 PM|El Padrino|Lekki|NGN 10000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=El+Padrino+Lekki+Lagos|FALSE|upcoming|@elpadrinong|Pool party — bring swimwear. Day into night.',
    '8|VVIP Night at Olas|nightlife-lounge|2026-12-19||10:00 PM|Olas|Victoria Island|Table from NGN 300000|DM to book|https://www.google.com/maps/search/?api=1&query=Olas+Victoria+Island+Lagos|FALSE|upcoming|@olas|Pay-for-section; the table is the guest list.',
    '9|Cabaret at The Library|nightlife-lounge|2026-12-13||9:00 PM|The Library Lagos|Victoria Island|NGN 20000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=The+Library+Lagos+Victoria+Island|TRUE|upcoming|@thelibrarylagos|Dinner-show, mostly live. Reservation-led — book the early sitting.',
    '10|Fela and the Kalakuta Queens|play-theatre|2026-12-21||3:00 PM & 7:00 PM|Terra Kulture|Victoria Island|NGN 15000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Terra+Kulture+Victoria+Island+Lagos|TRUE|upcoming|@terrakulture|BAP stage production; matinee and evening shows.',
    '11|AY Live — Christmas Edition|comedy|2026-12-25||5:00 PM|Eko Convention Centre|Victoria Island|NGN 25000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Eko+Convention+Centre+Victoria+Island+Lagos|FALSE|upcoming|@aymakun|Christmas Day staple. Go for the room, not the line-up.',
    '12|Contemporary Nigerian Art Show|art-culture|2026-12-05|2026-12-20|10:00 AM|kó Gallery|Ikoyi|Free||https://www.google.com/maps/search/?api=1&query=ko+Gallery+Ikoyi+Lagos|TRUE|upcoming|@ko_lagos|Free entry; quiet daytime culture between the late nights.',
    '13|Lagos Rave Series|nightlife-lounge|2026-12-27||8:00 PM|Muri Okunola Park|Victoria Island|NGN 18000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Muri+Okunola+Park+Victoria+Island+Lagos|FALSE|upcoming|@awelagos|Line-up drops closer to the date — watch the source.',
    '14|Juma Jux Live|concert|2026-12-18||6:00 PM|Ilubirin|Ikoyi|NGN 30000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=Ilubirin+Ikoyi+Lagos|FALSE|upcoming|@livespot360|Early-season concert; gates open long before the set.',
    '15|NYE Dinner at NOK by Alara|brunch-day-party|2026-12-31||8:00 PM|NOK by Alara|Victoria Island|NGN 50000|https://tix.africa/|https://www.google.com/maps/search/?api=1&query=NOK+by+Alara+Victoria+Island+Lagos|TRUE|sold_out|@noklagos|Sold out weeks ago. Ask us about the second sitting.',
    '16|Pending Review Example — New Party|nightlife-lounge|2026-12-23||9:00 PM|TBD|Lekki|TBD|||FALSE|pending|@whatshotinlagos|Awaiting team approval.'
  ];

  function esc(s) {
    return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function safeUrl(u) {
    return u && /^https:\/\//i.test(u) ? u : (u && /^http:\/\//i.test(u) ? u : '');
  }
  function titleCase(slug) {
    return String(slug || '').replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function toDate(iso) {
    if (!iso) return null;
    var m = String(iso).match(/(\d{4})-(\d{2})-(\d{2})/);
    return m ? new Date(+m[1], +m[2] - 1, +m[3], 12, 0, 0) : null;
  }
  // Lagos is UTC+1 year-round (no DST) — compute "today" in that zone
  // regardless of the visitor's own timezone, per the design spec.
  function lagosToday() {
    var now = new Date();
    var utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    var lagos = new Date(utcMs + 60 * 60000);
    return new Date(lagos.getFullYear(), lagos.getMonth(), lagos.getDate(), 12, 0, 0);
  }
  function fmtDay(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function money(s) {
    if (!s) return 'Price on request';
    return s.replace(/NGN\s*([\d,]+)/gi, function (_, n) { return '₦' + Number(n.replace(/,/g, '')).toLocaleString('en-US'); })
      .replace(/^Free-paid$/i, 'Free – paid')
      .replace(/^TBD$/i, 'Price TBD');
  }

  function splitLine(line, delim) {
    var out = [], cur = '', q = false;
    for (var i = 0; i < line.length; i++) {
      var c = line[i];
      if (q) {
        if (c === '"' && line[i + 1] === '"') { cur += '"'; i++; }
        else if (c === '"') q = false;
        else cur += c;
      } else if (c === '"') q = true;
      else if (c === delim) { out.push(cur); cur = ''; }
      else cur += c;
    }
    out.push(cur);
    return out.map(function (s) { return s.trim(); });
  }
  function parseRows(text, delim, hasHeader) {
    var lines = text.split(/\r?\n/).filter(function (l) { return l.trim().length; });
    if (!lines.length) return [];
    var cols = COLS, start = 0;
    if (hasHeader) {
      var head = splitLine(lines[0], delim).map(function (h) { return h.toLowerCase().replace(/\s+/g, '_'); });
      if (head.indexOf('event_name') > -1) { cols = head; start = 1; }
    }
    var rows = [];
    for (var i = start; i < lines.length; i++) {
      var cells = splitLine(lines[i], delim);
      var o = {};
      cols.forEach(function (c, idx) { o[c] = (cells[idx] || '').trim(); });
      if (o.event_name) rows.push(o);
    }
    return rows;
  }
  function parseSeed() { return parseRows(SEED.join('\n'), '|', false); }

  function icsStamp(d, time) {
    var t = String(time || '').match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    var h = 12, mi = 0;
    if (t) { h = (+t[1] % 12) + (/pm/i.test(t[3]) ? 12 : 0); mi = +t[2]; }
    function p(n) { return String(n).padStart(2, '0'); }
    return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + 'T' + p(h) + p(mi) + '00';
  }
  function icsEscape(s) { return String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,'); }
  function downloadIcs(r) {
    var start = toDate(r.date);
    if (!start) return;
    var end = toDate(r.end_date) || start;
    var s = icsStamp(start, r.time);
    var e = icsStamp(end, r.time).replace(/T(\d{2})/, function (m, hh) { return 'T' + String((+hh + 3) % 24).padStart(2, '0'); });
    var body = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Ezomi Concierge//Whats On//EN', 'BEGIN:VEVENT',
      'UID:ezomi-' + (r.id || Date.now()) + '@ezomiconcierge.com',
      'DTSTART:' + s, 'DTEND:' + e,
      'SUMMARY:' + icsEscape(r.event_name),
      'LOCATION:' + icsEscape([r.venue_name, r.area, 'Lagos'].filter(Boolean).join(', ')),
      'DESCRIPTION:' + icsEscape((r.notes || '').replace(/[\n,]/g, ' ') + ' — via Ezomi Concierge'),
      'END:VEVENT', 'END:VCALENDAR'
    ].join('\r\n');
    var blob = new Blob([body], { type: 'text/calendar' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = (r.event_name || 'event').replace(/[^\w]+/g, '-').toLowerCase() + '.ics';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
  }

  function chipHtml(action, value, label, active) {
    return '<button type="button" class="ezomi-whatson__chip' + (active ? ' ezomi-whatson__chip--active' : '') +
      '" data-action="' + action + '"' + (value ? ' data-value="' + esc(value) + '"' : '') + '>' + esc(label) + '</button>';
  }
  function chipSmHtml(action, value, label, active, ghost) {
    return '<button type="button" class="ezomi-whatson__chip-sm' + (active ? ' ezomi-whatson__chip-sm--active' : '') + (ghost ? ' ezomi-whatson__chip-sm--ghost' : '') +
      '" data-action="' + action + '" data-value="' + esc(value) + '">' + label + '</button>';
  }

  function EzomiWhatsOn(root) {
    this.root = root;
    var settingsEl = root.querySelector('[data-ezomi-settings]');
    this.settings = {};
    try { this.settings = JSON.parse((settingsEl && settingsEl.textContent) || '{}'); } catch (e) {}
    this.cacheKey = 'ezomi-whatson-cache-v1:' + (this.settings.sheetId || 'default');

    this.els = {
      season: root.querySelector('[data-ezomi-season]'),
      filterRow: root.querySelector('[data-ezomi-filter-row]'),
      moreToggle: root.querySelector('[data-ezomi-more-toggle]'),
      count: root.querySelector('[data-ezomi-count]'),
      morePanel: root.querySelector('[data-ezomi-more-panel]'),
      picks: root.querySelector('[data-ezomi-picks]'),
      content: root.querySelector('[data-ezomi-content]')
    };

    this.state = { rows: [], loading: true, live: false, cats: [], areas: [], thisWeek: false, exactDate: '', grouping: 'bands', expanded: null, moreOpen: false };
    this.loadPersisted();
    this.bindEvents();
    this.bootData();
  }

  EzomiWhatsOn.prototype.loadPersisted = function () {
    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (saved && typeof saved === 'object') {
        this.state.cats = saved.cats || [];
        this.state.areas = saved.areas || [];
        this.state.thisWeek = !!saved.thisWeek;
        this.state.grouping = saved.grouping || 'bands';
      }
    } catch (e) {}
  };
  EzomiWhatsOn.prototype.persist = function () {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ cats: this.state.cats, areas: this.state.areas, thisWeek: this.state.thisWeek, grouping: this.state.grouping }));
    } catch (e) {}
  };

  EzomiWhatsOn.prototype.readCache = function () {
    try {
      var raw = localStorage.getItem(this.cacheKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && Array.isArray(parsed.rows)) return parsed;
    } catch (e) {}
    return null;
  };
  EzomiWhatsOn.prototype.writeCache = function (rows) {
    try { localStorage.setItem(this.cacheKey, JSON.stringify({ ts: Date.now(), rows: rows })); } catch (e) {}
  };

  EzomiWhatsOn.prototype.bootData = function () {
    if (!this.settings.sheetId) {
      // Nothing configured at all (e.g. previewing the section before setup)
      // — sample data only, never presented as if it were live.
      this.state.rows = parseSeed();
      this.state.live = false;
      this.state.loading = false;
      this.render();
      return;
    }
    var cached = this.readCache();
    var maxAge = (Number(this.settings.cacheMinutes) || 10) * 60000;
    if (cached && Array.isArray(cached.rows) && (Date.now() - cached.ts < maxAge)) {
      // Verified current as of less than `cacheMinutes` ago — trust it
      // without a network round trip.
      this.state.rows = cached.rows;
      this.state.live = true;
      this.state.loading = false;
      this.render();
      return;
    }
    // No cache we can still trust — show the real loading state and wait
    // for a verified answer rather than guessing with stale or sample data.
    this.state.loading = true;
    this.render();
    this.fetchSheet();
  };

  EzomiWhatsOn.prototype.fetchSheet = function () {
    var self = this;
    var url = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(this.settings.sheetId) + '/gviz/tq?tqx=out:csv';
    fetch(url, { cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('http ' + res.status);
      return res.text();
    }).then(function (text) {
      var lines = text.split(/\r?\n/).filter(function (l) { return l.trim().length; });
      if (!lines.length) throw new Error('empty response');
      var head = splitLine(lines[0], ',').map(function (h) { return h.toLowerCase().replace(/\s+/g, '_'); });
      if (head.indexOf('event_name') === -1) throw new Error('unrecognized response shape');
      // A well-formed response from our own sheet — trust it even if there
      // are zero data rows; that's the sheet's real current state, not a failure.
      var rows = parseRows(text, ',', true);
      self.writeCache(rows);
      self.setState({ rows: rows, live: true, loading: false });
    }).catch(function () {
      // A genuine failure (network error, bad status, or a response that
      // doesn't look like our sheet at all) — reflect that honestly rather
      // than falling back to stale or sample data.
      self.setState({ rows: [], live: false, loading: false });
    });
  };

  EzomiWhatsOn.prototype.setState = function (patch) {
    Object.assign(this.state, patch);
    this.render();
  };
  EzomiWhatsOn.prototype.toggleIn = function (key, val) {
    var list = this.state[key];
    var next = list.indexOf(val) > -1 ? list.filter(function (v) { return v !== val; }) : list.concat([val]);
    this.state[key] = next;
    this.persist();
    this.render();
  };
  EzomiWhatsOn.prototype.findRow = function (id) {
    var rows = this.state.rows;
    for (var i = 0; i < rows.length; i++) if (String(rows[i].id) === String(id)) return rows[i];
    return null;
  };

  EzomiWhatsOn.prototype.revealCard = function (id) {
    var root = this.root;
    function target() {
      var el = null;
      try { el = root.querySelector('[data-event-id="' + CSS.escape(String(id)) + '"]'); } catch (e) {}
      return el ? Math.max(0, el.getBoundingClientRect().top + (window.pageYOffset || 0) - 150) : null;
    }
    function go() {
      var y = target();
      if (y === null) return;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setTimeout(function () {
        var want = target();
        if (want !== null && Math.abs((window.pageYOffset || 0) - want) > 24) window.scrollTo(0, want);
      }, 420);
    }
    requestAnimationFrame(function () { requestAnimationFrame(go); });
    setTimeout(go, 60);
  };

  EzomiWhatsOn.prototype.computeViewModel = function () {
    var S = this.state;
    var today = lagosToday();
    var DAY = 86400000;
    var showImages = this.settings.showImages !== false;

    var approved = S.rows.filter(function (r) {
      return ['upcoming', 'this_week', 'sold_out', 'postponed'].indexOf((r.status || '').toLowerCase()) > -1;
    });
    var live = approved.map(function (r) {
      return { r: r, start: toDate(r.date), end: toDate(r.end_date) || toDate(r.date) };
    }).filter(function (x) { return x.start && x.end >= today; })
      .sort(function (a, b) { return a.start - b.start; });

    var cats = [], areas = [];
    live.forEach(function (x) {
      var c = (x.r.category || '').toLowerCase();
      if (c && cats.indexOf(c) === -1) cats.push(c);
      if (x.r.area && areas.indexOf(x.r.area) === -1) areas.push(x.r.area);
    });

    var exact = toDate(S.exactDate);
    var filtered = live.filter(function (x) {
      var r = x.r;
      if (S.cats.length && S.cats.indexOf((r.category || '').toLowerCase()) === -1) return false;
      if (S.areas.length && S.areas.indexOf(r.area) === -1) return false;
      if (S.thisWeek && !(x.start <= new Date(today.getTime() + 7 * DAY) && x.end >= today)) return false;
      if (exact && !(x.start <= exact && x.end >= exact)) return false;
      return true;
    });

    var view = filtered.map(function (x) {
      var r = x.r, start = x.start, end = x.end;
      var cat = (r.category || '').toLowerCase();
      var tag = TAGS[cat] || FALLBACK_TAG;
      var status = (r.status || '').toLowerCase();
      var soldOut = status === 'sold_out';
      var postponed = status === 'postponed';
      var onNow = start <= today && end >= today && end > start;
      var pick = String(r.ezomi_pick).toUpperCase() === 'TRUE';
      var expanded = S.expanded === r.id;
      var dm = !r.ticket_url || /dm to book/i.test(r.ticket_url);
      var multi = end > start;
      var dateLabel = multi ? (start.getDate() + ' – ' + end.getDate() + ' ' + MONTHS[end.getMonth()]) : fmtDay(start);
      var timeLabel = !r.time || /varies/i.test(r.time) ? 'Times vary' : r.time;
      var image = safeUrl((r.image_url || '').trim());
      return {
        id: r.id, name: r.event_name, categoryLabel: LABELS[cat] || titleCase(cat),
        tagBg: tag.bg, tagFg: tag.fg, isPick: pick, soldOut: soldOut, postponed: postponed, onNow: onNow, expanded: expanded,
        showThumb: showImages, hasImage: showImages && !!image, noImage: showImages && !image,
        hasBigImage: !!image, image: image, dateLabel: dateLabel,
        whenLine: dateLabel + ' · ' + timeLabel,
        metaLine: [r.venue_name, r.area, money(r.price_from)].filter(Boolean).join(' · '),
        note: r.notes, hasNote: !!r.notes,
        source: r.source || '@ezomiconcierge',
        bookingLine: soldOut ? 'Sold out — ask us about a second sitting.' : (dm ? 'No online tickets — booked directly through the venue or our DMs.' : 'Tickets through ' + r.ticket_url.replace(/^https?:\/\//, '').replace(/\/$/, '')),
        ctaLabel: soldOut ? 'Sold out' : (dm ? 'How to attend' : 'Get tickets')
      };
    });

    var groups;
    if (S.grouping === 'flat' || exact) {
      groups = view.length ? [{ label: exact ? fmtDay(exact) : 'Soonest first', count: view.length + (view.length === 1 ? ' event' : ' events'), items: view }] : [];
    } else {
      var bandDefs = [
        { label: 'This week', test: function (d) { return d <= 7; } },
        { label: 'Next week', test: function (d) { return d <= 14; } },
        { label: 'Later on', test: function () { return true; } }
      ];
      var bands = bandDefs.map(function (b) { return { label: b.label, band: b, items: [] }; });
      filtered.forEach(function (x, i) {
        var d = Math.floor((x.start - today) / DAY);
        var g = bands.filter(function (g) { return g.band.test(d); })[0];
        g.items.push(view[i]);
      });
      groups = bands.filter(function (g) { return g.items.length; }).map(function (g) {
        return { label: g.label, count: g.items.length + (g.items.length === 1 ? ' event' : ' events'), items: g.items };
      });
    }

    var months = [];
    live.forEach(function (x) {
      var m = FULL_MONTHS[x.start.getMonth()] + ' ' + x.start.getFullYear();
      if (months.indexOf(m) === -1) months.push(m);
    });
    var span = months.length > 1 ? (months[0].split(' ')[0] + ' – ' + months[months.length - 1]) : (months[0] || '');

    var picks = view.filter(function (v) { return v.isPick && !v.soldOut; }).slice(0, 5);
    var anyFilter = !!(S.cats.length || S.areas.length || S.thisWeek || S.exactDate);

    return {
      isLoading: S.loading && !S.rows.length,
      isEmpty: !S.loading && !view.length,
      seasonLine: [span, 'Updated daily'].filter(Boolean).join(' · '),
      countLine: view.length === 1 ? '1 event' : view.length + ' events',
      showPicksStrip: this.settings.showPicksStrip !== false && picks.length > 0,
      picks: picks, groups: groups, cats: cats, areas: areas, anyFilter: anyFilter
    };
  };

  EzomiWhatsOn.prototype.cardHtml = function (ev) {
    var classes = ['ezomi-whatson__card'];
    if (ev.isPick) classes.push('ezomi-whatson__card--pick');
    if (ev.soldOut) classes.push('ezomi-whatson__card--soldout');
    if (ev.expanded) classes.push('ezomi-whatson__card--expanded');

    var badges = '<span class="ezomi-whatson__badge" style="background:' + ev.tagBg + ';color:' + ev.tagFg + ';">' + esc(ev.categoryLabel) + '</span>';
    if (ev.isPick) badges += '<span class="ezomi-whatson__badge ezomi-whatson__badge--pick">Ezomi Pick</span>';
    if (ev.soldOut) badges += '<span class="ezomi-whatson__badge ezomi-whatson__badge--soldout">Sold out</span>';
    if (ev.postponed) badges += '<span class="ezomi-whatson__badge ezomi-whatson__badge--postponed">Postponed</span>';
    if (ev.onNow) badges += '<span class="ezomi-whatson__badge ezomi-whatson__badge--onnow">On now</span>';

    var thumb = '';
    if (ev.showThumb) {
      thumb = '<div class="ezomi-whatson__thumb">' + (
        ev.hasImage
          ? '<div class="ezomi-whatson__thumb-img" style="background-image:url(\'' + esc(ev.image) + '\');"></div>'
          : '<img src="' + esc(this.settings.iconUrl) + '" alt="" class="ezomi-whatson__thumb-placeholder">'
      ) + '</div>';
    }

    var expand = '';
    if (ev.expanded) {
      expand = '<div class="ezomi-whatson__expand">';
      if (ev.hasBigImage) expand += '<div class="ezomi-whatson__expand-image" style="background-image:url(\'' + esc(ev.image) + '\');"></div>';
      if (ev.hasNote) expand += '<div class="ezomi-whatson__tip"><span class="ezomi-whatson__tip-label">Notes</span><p class="ezomi-whatson__tip-text">' + esc(ev.note) + '</p></div>';
      expand += '<div class="ezomi-whatson__booking"><span>' + esc(ev.bookingLine) + '</span><span>Seen on ' + esc(ev.source) + '</span></div>';
      expand += '<div class="ezomi-whatson__actions">';
      expand += '<button type="button" class="ezomi-whatson__btn ezomi-whatson__btn--primary" data-action="tickets" data-id="' + esc(ev.id) + '"' + (ev.soldOut ? ' disabled' : '') + '>' + esc(ev.ctaLabel) + '</button>';
      expand += '<button type="button" class="ezomi-whatson__btn ezomi-whatson__btn--outline" data-action="directions" data-id="' + esc(ev.id) + '">Directions</button>';
      expand += '<button type="button" class="ezomi-whatson__btn ezomi-whatson__btn--ghost" data-action="calendar" data-id="' + esc(ev.id) + '">Add to calendar</button>';
      expand += '</div></div>';
    }

    return '<article class="' + classes.join(' ') + '" data-event-id="' + esc(ev.id) + '" data-action="toggle-card" role="button" tabindex="0" aria-expanded="' + ev.expanded + '">' +
      '<div class="ezomi-whatson__card-row">' + thumb +
        '<div class="ezomi-whatson__card-body">' +
          '<div class="ezomi-whatson__badges">' + badges + '</div>' +
          '<h3 class="ezomi-whatson__card-title">' + esc(ev.name) + '</h3>' +
          '<span class="ezomi-whatson__card-when">' + esc(ev.whenLine) + '</span>' +
          '<span class="ezomi-whatson__card-meta">' + esc(ev.metaLine) + '</span>' +
        '</div>' +
      '</div>' + expand +
      '</article>';
  };

  EzomiWhatsOn.prototype.render = function () {
    var vm = this.computeViewModel();
    var S = this.state;
    var els = this.els;
    var self = this;

    els.season.textContent = vm.seasonLine;

    var chipsHtml = chipHtml('all', '', 'All', !vm.anyFilter) + chipHtml('this-week', '', 'This week', S.thisWeek) +
      '<span class="ezomi-whatson__chip-divider" aria-hidden="true"></span>';
    vm.cats.forEach(function (c) { chipsHtml += chipHtml('cat', c, LABELS[c] || titleCase(c), S.cats.indexOf(c) > -1); });
    els.filterRow.innerHTML = chipsHtml;

    els.moreToggle.textContent = S.moreOpen ? 'Fewer filters' : 'Area, date & grouping';
    els.moreToggle.setAttribute('aria-expanded', String(S.moreOpen));
    els.count.textContent = vm.countLine;

    if (S.moreOpen) {
      var areaHtml = vm.areas.map(function (a) { return chipSmHtml('area', a, esc(a), S.areas.indexOf(a) > -1); }).join('');
      var groupHtml = chipSmHtml('group', 'bands', 'By date band', S.grouping === 'bands') + chipSmHtml('group', 'flat', 'Soonest first', S.grouping === 'flat');
      els.morePanel.innerHTML =
        '<div class="ezomi-whatson__more-group"><span class="ezomi-whatson__more-label">Area</span><div class="ezomi-whatson__chiprow-wrap">' + (areaHtml || '<span class="ezomi-whatson__hint">No areas yet</span>') + '</div></div>' +
        '<div class="ezomi-whatson__more-group"><span class="ezomi-whatson__more-label">On a specific date</span><div class="ezomi-whatson__date-row">' +
          '<input type="date" class="ezomi-whatson__date-input" data-action="date-input" value="' + esc(S.exactDate) + '">' +
          (S.exactDate ? chipSmHtml('clear-date', '', 'Clear', false, true) : '') +
        '</div></div>' +
        '<div class="ezomi-whatson__more-group"><span class="ezomi-whatson__more-label">Group</span><div class="ezomi-whatson__chiprow-wrap">' + groupHtml + '</div></div>';
      els.morePanel.hidden = false;
    } else {
      els.morePanel.innerHTML = '';
      els.morePanel.hidden = true;
    }

    if (vm.showPicksStrip) {
      els.picks.hidden = false;
      els.picks.innerHTML = '<span class="ezomi-whatson__picks-label">Ezomi Picks</span>' + vm.picks.map(function (p) {
        return '<button type="button" class="ezomi-whatson__pick" data-action="open-pick" data-id="' + esc(p.id) + '"><span class="ezomi-whatson__pick-date">' + esc(p.dateLabel) + '</span><span>' + esc(p.name) + '</span></button>';
      }).join('');
    } else {
      els.picks.hidden = true;
      els.picks.innerHTML = '';
    }

    var contentHtml = '';
    vm.groups.forEach(function (g) {
      contentHtml += '<section class="ezomi-whatson__group"><div class="ezomi-whatson__group-head"><h2 class="ezomi-whatson__group-label">' + esc(g.label) + '</h2><span class="ezomi-whatson__group-rule"></span><span class="ezomi-whatson__group-count">' + esc(g.count) + '</span></div><div class="ezomi-whatson__grid">';
      g.items.forEach(function (ev) { contentHtml += self.cardHtml(ev); });
      contentHtml += '</div></section>';
    });
    if (vm.isEmpty) {
      contentHtml += '<div class="ezomi-whatson__empty"><img src="' + esc(this.settings.iconUrl) + '" alt="" class="ezomi-whatson__empty-icon">' +
        '<p class="ezomi-whatson__empty-text">Nothing in this vibe yet — check back, we update daily.</p>' +
        '<button type="button" class="ezomi-whatson__btn ezomi-whatson__btn--outline" data-action="all">Show everything</button></div>';
    }
    if (vm.isLoading) {
      contentHtml += '<div class="ezomi-whatson__loading">Pulling this week&rsquo;s list&hellip;</div>';
    }
    els.content.innerHTML = contentHtml;
  };

  EzomiWhatsOn.prototype.bindEvents = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-action]');
      if (!el || !self.root.contains(el)) return;
      self.handleAction(el);
    });
    this.root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target.closest('[data-action="toggle-card"]');
      if (!el) return;
      e.preventDefault();
      self.handleAction(el);
    });
    this.root.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-action="date-input"]')) {
        self.setState({ exactDate: e.target.value });
      }
    });
  };

  EzomiWhatsOn.prototype.handleAction = function (el) {
    var action = el.getAttribute('data-action');
    var value = el.getAttribute('data-value');
    var id = el.getAttribute('data-id') || el.getAttribute('data-event-id');

    if (action === 'all') {
      this.state.cats = []; this.state.areas = []; this.state.thisWeek = false; this.state.exactDate = '';
      this.persist(); this.render();
    } else if (action === 'this-week') {
      this.state.thisWeek = !this.state.thisWeek; this.persist(); this.render();
    } else if (action === 'cat') {
      this.toggleIn('cats', value);
    } else if (action === 'area') {
      this.toggleIn('areas', value);
    } else if (action === 'toggle-more') {
      this.state.moreOpen = !this.state.moreOpen; this.render();
    } else if (action === 'clear-date') {
      this.state.exactDate = ''; this.render();
    } else if (action === 'group') {
      this.state.grouping = value; this.persist(); this.render();
    } else if (action === 'open-pick') {
      this.state.expanded = id;
      this.render();
      this.revealCard(id);
    } else if (action === 'toggle-card') {
      this.state.expanded = (this.state.expanded === id) ? null : id;
      this.render();
    } else if (action === 'tickets') {
      var row = this.findRow(id);
      if (!row || (row.status || '').toLowerCase() === 'sold_out') return;
      var dm = !row.ticket_url || /dm to book/i.test(row.ticket_url);
      var target = dm ? this.settings.dmUrl : safeUrl(row.ticket_url);
      if (target) window.open(target, dm ? '_self' : '_blank', 'noopener');
    } else if (action === 'directions') {
      var row2 = this.findRow(id);
      var mapUrl = row2 && safeUrl(row2.map_url);
      if (mapUrl) window.open(mapUrl, '_blank', 'noopener');
    } else if (action === 'calendar') {
      var row3 = this.findRow(id);
      if (row3) downloadIcs(row3);
    }
  };

  function boot() {
    var roots = document.querySelectorAll('.ezomi-whatson[data-ezomi-root]:not([data-ezomi-booted])');
    roots.forEach(function (root) {
      root.setAttribute('data-ezomi-booted', 'true');
      new EzomiWhatsOn(root);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
